// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"324":"9b7eb620362c897b","525":"199133ffb7580804"}[chunkId] + ".js";
};